import { t } from "i18next"
import ValidationsCommon from "../../../utils/Validations";
const Validations = () => ({
    ...ValidationsCommon(),
    name: (errors, value) => {
        if (!value) {
            errors.name = (t("Required field", {ns: "messages"}));
        } else if (
            !/^[^<>]{1,300}$/g.test(
                value
            )
        ) {
            errors.name = (t("Invalid name format", {ns: "messages"}));
        }
    },
    notice: (errors, value) => {
        if (!value) {
        } else if (
            !/^[^<>]*$/g.test(
                value
            )
        ) {
            errors.notice = (t("Invalid notice format", {ns: "messages"}));
        }
    },
    address: (errors, value) => {
        if (!value) {
          } else if (
            !/^[^<>]{1,500}$/g.test(
                value
            )
          ) {
            errors.address = (t("Invalid address format", {ns: "messages"}));
        }
    },
    location: (errors, value) => {
        if(!value || (!value.latitude && !value.longitude)) {
        } else if(!value.latitude) {
            errors.location = {}
            errors.location.latitude = (t("Required field", { ns: "messages" }));
        } else if(!value.longitude) {
            errors.location = {}
            errors.location.longitude = (t("Required field", { ns: "messages" }));
        }
    },
    email: (errors, value) => {
        if(!value) {
        } else if(!/^[a-zA-Zа-яА-Я0-9_.+-]+@[a-zA-Zа-яА-Я0-9-]+\.[a-zA-Zа-яА-Я0-9-.]+$/gm.test(value)) {
            errors.email = (t("Invalid email format", { ns: "messages" }));
        }
    },
    phone: (errors, value) => {
        if(!value) {
        } else if(value.length < 11){
            errors.phone = (t("Invalid number format", {ns: "messages"}));
        }
    },
    numberDocuments: (errors, value) => {
        if (!value) {
            errors.numberDocuments = (t("Required field", {ns: "messages"}));
        } else if (
            !/^[^<>]{1,300}$/g.test(
                value
            )
        ) {
            errors.numberDocuments = (t("Invalid document number format", {ns: "messages"}));
        }
    },
    responsible: (errors, value) => {
        if (!value) {
            errors.responsible = (t("Required field", {ns: "messages"}));
        } else if (
            !/^[^<>]{1,300}$/g.test(
                value
            )
        ) {
            errors.responsible = (t("Invalid responsible format", {ns: "messages"}));
        }
    },
    comment: (errors, value) => {
        if (!value) {
            errors.comment = (t("Required field", {ns: "messages"}));
        } else if (
            !/^[^<>]{1,300}$/g.test(
                value
            )
        ) {
            errors.comment = (t("Invalid comment format", {ns: "messages"}));
        }
    },
});

export default Validations;